// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-3be9a0d3] {\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  padding: 20px;\n}\n.right-container[data-v-3be9a0d3] {\n  float: left;\n  width: calc(100% - 240px);\n  height: 100%;\n}\n.list-container[data-v-3be9a0d3] {\n  width: 100%;\n}\n.list-container .toolbar[data-v-3be9a0d3] {\n  width: 100%;\n  height: 50px;\n}\n[data-v-3be9a0d3] .el-tabs__item {\n  height: 50px;\n  line-height: 50px;\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
